import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get('admin_token') || '',
    adminInfo: JSON.parse(localStorage.getItem('adminInfo') || '{}')
  },
  getters: {
    token: state => state.token,
    adminInfo: state => state.adminInfo,
    role: state => state.adminInfo.role || ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      Cookies.set('admin_token', token, { expires: 1 })
    },
    SET_ADMIN_INFO(state, info) {
      state.adminInfo = info
      localStorage.setItem('adminInfo', JSON.stringify(info))
    },
    CLEAR(state) {
      state.token = ''
      state.adminInfo = {}
      Cookies.remove('admin_token')
      localStorage.removeItem('adminInfo')
    }
  },
  actions: {
    login({ commit }, data) {
      commit('SET_TOKEN', data.token)
      commit('SET_ADMIN_INFO', {
        adminId: data.adminId,
        username: data.username,
        realName: data.realName,
        role: data.role
      })
    },
    logout({ commit }) {
      commit('CLEAR')
    }
  }
})
